import { createContext } from 'react';
import { GetRatesContextType } from '../../pages/GetRatesV2/Type';

const GetRatesContext = createContext<GetRatesContextType | null>(null);

export default GetRatesContext;
